/**
 * SPDX-FileCopyrightText: (c) 2000 Liferay, Inc. https://liferay.com
 * SPDX-License-Identifier: LGPL-2.1-or-later OR LicenseRef-Liferay-DXP-EULA-2.0.0-2023-06
 */

import {State} from '@liferay/frontend-js-state-web';

export const activeLanguageIdsAtom = State.atom<Liferay.Language.Locale[]>(
	'activeLocaleIds',
	[]
);
export const selectedLanguageIdAtom = State.atom<Liferay.Language.Locale>(
	'selectedLocaleId',
	'en_US'
);
